module.exports = __webpack_public_path__ + "img/siege_ballista_small.d75a16b2.png";